module.exports = __webpack_public_path__ + "img/food5.1b8c31ab.png";